import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "product-list" };
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Companies", -1)),
        _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: product.id,
                    class: "product-card"
                }, [
                    _createElementVNode("h2", null, _toDisplayString(product.name), 1),
                    _createElementVNode("p", null, _toDisplayString(product.description), 1),
                    _createElementVNode("p", null, "Price: " + _toDisplayString(product.price), 1),
                    _createElementVNode("button", {
                        onClick: ($event) => (_ctx.addToCart(product))
                    }, "Add to Cart", 8, _hoisted_2)
                ]));
            }), 128))
        ])
    ]));
}
